
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 52 52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48.701 47.125a3.25 3.25 0 01-3.25 3.25h-38.9a3.25 3.25 0 01-3.25-3.25V4.875a3.25 3.25 0 013.25-3.25h32.5a3.25 3.25 0 012.268.923l6.403 6.246a3.25 3.25 0 01.98 2.327v36.004z","fill":"#fff","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.926 21.125a4.875 4.875 0 100-9.75 4.875 4.875 0 000 9.75z","fill":"#fff","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.762 39.434l-8.504-12.757a2.19 2.19 0 00-3.62-.041l-5.83 8.33-3.615-2.898a2.19 2.19 0 00-3.193.496l-4.574 6.87","fill":"#fff"}}),_c('path',{attrs:{"d":"M40.762 39.434l-8.504-12.757a2.19 2.19 0 00-3.62-.041l-5.83 8.33-3.615-2.898a2.19 2.19 0 00-3.193.496l-4.574 6.87","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    